import React, { useEffect } from 'react'
import Button from '../../../../partials/Button'

const Buttons = (props) => {
    
    const { buttonSet, className } = props

    useEffect( () => {

    }, [buttonSet])

    return (
        <div className={className}>
            {buttonSet.map((button, index) =>{

                if(button.hide) return false
                else return (
                    <Button 
                        key={index}
                        className={`small ${button.className}`}
                        text={button.text} 
                        disabled={button.disabled}
                        onClick={button.action} />
                )
            })

        }
            
        </div>
    )
}

export default Buttons